
import { t } from '@process-creative/slate-theme-tools';

$(x => WishlistPage(x('.wishlistpage')[0]))


function WishlistPage(container){
  if(!container) return

  const pageVisibility = {
    _visible: true,
    set visible(isTrue){ 
      $(container).css('display', isTrue ? 'block' : 'none')
      this._visible = isTrue
    }
  }

  pageVisibility.visible = false

  const changeObserver = new MutationObserver(() => {
    applyProcessStyles() 
    ifNoProductsHideHeaderButtons()
  })
  startObserving()
  handleRemoveAll()



  /* Utility Function */

  function startObserving(){
    changeObserver.observe(container, { attributes: true, childList: true, subtree: true });
  }
  function stopObserving(){
    changeObserver.disconnect()
  }


  function applyProcessStyles(){

    stopObserving()
    {
      addToCartButtons()
      removeButtons()
      spacingAndLayout()
      modals()
      miscellaneousFixes()
      pageVisibility.visible = true

    }
    startObserving()


    function addToCartButtons(){
      const allAddButtons = $(container).find('.addbutton, .sharebutton')
      allAddButtons.removeClass('btn btn-primary btn-info')
      
      allAddButtons.addClass('o-btn')
      allAddButtons.find('i.fa-shopping-cart').remove()

    }
    function removeButtons(){
      const allRemoveButtons = $(container).find('.removebutton')
      allRemoveButtons.removeClass('btn btn-warning')
      allRemoveButtons.addClass('o-btn is-primary')

    }
    function spacingAndLayout(){
      

      // body
      const wishlistbodycontainer = $(container).find('.wishlistbodycontainer')
      wishlistbodycontainer.removeClass('container')

      

      const productElems = wishlistbodycontainer.find('.product')
      productElems.each((i, prod) => {
        const product = $(prod)
        const productClass = 'o-product-thumbnail c-collection__product o-products-list__product'
        const innerContainerClass = 'o-product-thumbnail__inner'
        const imgContainerClass = 'o-product-thumbnail__image-container o-responsive-image__container'
        const imgClass = 'o-product-thumbnail__image o-responsive-image'
        const detailsClass = 'o-product-thumbnail__details'

        const productIdSelector = product.parent().attr('id')

        checkParentAndUnwrap()
        function checkParentAndUnwrap(){
          if(product.parent().hasClass('wishlistbodycontainer') == false){
            product.unwrap()
            checkParentAndUnwrap()
          }
        }
        product.wrap(`<div id="${productIdSelector}" class="${productClass}"></div>`)
        product.removeClass('product')
        product.addClass(innerContainerClass)

        
        const imgContainer = product.find('.image')
        imgContainer.removeClass('image')
        imgContainer.addClass(imgContainerClass)

        const img = imgContainer.find('.img-responsive')
        img.removeClass('img-responsive')
        img.addClass(imgClass)
        
        const subContainer = product.find('.text')
        subContainer.removeClass('text')
        subContainer.addClass(detailsClass)

        const detatchedButtonsElem = product.find('.buttons').detach()
        product.after(detatchedButtonsElem)

      })

      
      wishlistbodycontainer.find('.clear').remove()
      wishlistbodycontainer.find('.row').remove()
      wishlistbodycontainer.addClass('c-collection-list__container')


    }
    function miscellaneousFixes(){

      
      const topSection = $(container).find('.wishlisttitlecontainer')
      topSection.removeClass('container')
      
      const h1 = $(container).find('.titletext')
      h1.removeClass('titletext')

      
      const loginmessage = $(container).find('.loginmessage')
      loginmessage.removeClass('row')
      
      
      const topButtons = $(container).find('.allbuttons')
      topButtons.removeClass('col-md-6')

      
      h1.length > 0 && checkParentAndUnwrap()
      function checkParentAndUnwrap(){
        if(h1.parent().hasClass('wishlisttitlecontainer') == false){
          h1.unwrap()
          checkParentAndUnwrap()
        }
      }


    }
    function modals(){
      const modals = $('#variant_selection_modal, #remove_modal, #remove_all_modal')
      
      const chooseButton = modals.find('.btn-primary-modal')
      chooseButton.removeClass('btn btn-primary btn-primary-modal')
      chooseButton.addClass('o-btn')

      
      const closeButton = modals.find('.btn-default-modal')
      closeButton.removeClass('btn btn-default btn-default-modal')
      closeButton.addClass('o-btn is-primary')

      
      const removeButton = modals.find('.btn-warning-modal')
      removeButton.removeClass('btn btn-warning btn-warning-modal')
      removeButton.addClass('o-btn')

      
      
      
    }
  }

  function ifNoProductsHideHeaderButtons(){

    const emptyElem = /*html*/`
    <div class='wishlist-empty'>
      <p>${t('wishlist.empty_wishlist')}</p>
      <a href="/collections/best-sellers" class="o-btn">
        ${t('wishlist.view_products')}
      </a>
    </div>
    `

    const noProducts = (container.querySelectorAll('.o-product-thumbnail').length == 0)
    if(noProducts){
      $('.allbuttons').addClass('is-hidden')
      if(!$('.wishlist-empty').length){
        $('.wishlistbodycontainer').append(emptyElem)
      }
    }
    else{
      $('.allbuttons').removeClass('is-hidden')
      $('.wishlist-empty').remove()
    }
  }

  function handleRemoveAll(){
    $(document).on('click', '#modal_remove_all_button', e => {
      $('.wishlistbodycontainer').html('')
    })
  }
}